<template>
  <div class="custvolume">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>客户报检量统计</span>
      </div>
      <!-- card header -->
      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="7">
          <el-date-picker
            v-model="pickerDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            unlink-panels
            :picker-options="pickerOptions"
            @change="handleDateChange"
          >
          </el-date-picker>
        </el-col>
        <!-- 搜索 -->
        <el-col :span="1">
          <el-button
            icon="el-icon-search"
            type="primary"
            plain
            @click="search"
          ></el-button>
        </el-col>
        <el-col :span="15">&nbsp;</el-col>
        <!-- 下载 -->
        <el-col :span="1">
          <el-button
            v-if="custList.length != 0"
            icon="el-icon-download"
            type="info"
            plain
            :loading="downloadLoading"
            @click="download"
          ></el-button>
        </el-col>
      </el-row>
      <!-- 表格 -->
      <TzTable :tableData="custList" :columns="columns" />
      <!-- 表格 -->
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import {
  customerCountDevice,
  customerCountDeviceDownload
} from '@/api/custvolume'
import TzTable from '@/components/tz-table/Index.vue'
import fileDownload from 'js-file-download'
export default {
  components: {
    TzTable
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      editState: false,
      downloadLoading: false,
      editUnit: {},
      custList: [],
      pickerDate: [], //日期
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },
      columns: [
        {
          field: 'invoiceTitle',
          title: '客户单位名称',
          width: '200'
        }
      ],
      unitname: ''
    }
  },
  methods: {
    //选择日期事件
    handleDateChange(dialogPickerDate) {
      if (dialogPickerDate == null) {
        this.pickerDate = []
      }
      this.page = 1
      this.getCustList()
    },
    handleSizeChange(val) {
      this.size = val
      this.getCustList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getCustList()
    },
    // 列表
    getCustList() {
      let custparams = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        offset: (this.page - 1) * this.size,
        limit: this.size
      }
      customerCountDevice(custparams).then((res) => {
        console.log(res.data, '客户单位名称')
        if (res.code == 200) {
          this.columns = [
            {
              field: 'invoiceTitle',
              title: '客户单位名称',
              width: '200'
            }
          ]
          this.total = res.data.total
          this.custList = res.data.rows
          let equipList = res.data.equipmentType
          equipList.forEach((ele) => {
            let obj = {
              field: ele.label,
              title: ele.label,
              value: ele.value
            }
            this.columns.push(obj)
          })
          this.custList.forEach((item) => {
            item.infos.forEach((ele) => {
              let obj1 = {}
              obj1[ele.deviceTypeName] = ele.count
              Object.assign(item, obj1)
            })
          })
        }
      })
    },
    //下载
    download() {
      this.downloadLoading = true
      var data = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      customerCountDeviceDownload(data).then((res) => {
        fileDownload(res, '客户报检量统计.xlsx')
      })
      this.downloadLoading = false
    },
    // 点击搜索
    search() {
      this.getCustList()
    }
  },
  mounted() {
    this.getCustList()
  }
}
</script>

<style></style>
